export const DATA = [
	{
		category: "Manage your account",
		description: "Morbi leo risus porta consectetur vestibulum ateros",
		icon: "account_circle",
		links: [
			"Proin vel nisl vel urna ultricies vulputate",
			"Aenean euismod dolor quis ante pharetra egestas",
			"Sed eu eros ornare tempus libero non malesuada ligula",
			"Praesent in enim vitae turpis scelerisque euismod",
			"Vivamus blandit dolor nec efficitur placerat",
		],
	},
	{
		category: "Payment and billing",
		description: "Etiam consectetur duiut felis gravida laoreet",
		icon: "paid",
		links: [
			"Mauris in turpis volutpat sagittis nisnec convallis risus",
			"Fusce sit amet dolor quis est ultricies luctus",
			"Donec etui nec purus posuere malesuada tempor",
			"Sed consectetur dolor non massa vulputate blandit",
			"Vestibulum cursus consectetur inatest",
		],
	},
	{
		category: "Legal and privacy",
		description: "Etiam sagittis neque finibus rutrum faucibus",
		icon: "verified_user",
		links: [
			"Proin sed justo sed miandit posuere.",
			"Mauris tempor arcu euosuere luctus",
			"Maecenas eget orci eget orci semper dapibus",
			"Donec sitamet odioet felis hendrerit hendrerit",
			"Aliquam auctor tellus aeros dapibus efficitur",
		],
	},
	{
		category: "Login and registration",
		description: "Duis scelerisque rhoncus semid gravida",
		icon: "login",
		links: [
			"Quisque commodo felis non ultricies finibus.",
			"Phasellus risus felis cursus venenatis tristique viverra.",
			"Vestibulum odio risus faucibus semper congue lorem.",
			"Mauris lacinia metus quis viverra volutpat.",
			"Praesent vitae tellus id ligula tincidunt molestie.",
		],
	},
	{
		category: "User interface and experience",
		description: "Curabitur sesem uturna volutpat vestibulum",
		icon: "ads_click",
		links: [
			"Aliquam facilisis orciet massa ultrices.",
			"Maecenas volutpat nisiac consectetur viverra.",
			"Proin efficitur lectus nec tincidunt pharetra.",
			"Cras sodales metus inarcu molestie molestie.",
			"Nullam volutpat orci bibendum felis egestas.",
		],
	},
	{
		category: "Everything else",
		description: "Curabitur sesem uturna volutpat vestibulum",
		icon: "apps",
		links: [
			"Donec laoreet nisl eget porta luctus.",
			"Quisque non tellus inarcu iaculis porttitora.",
			"Proin efficitur lectus nec tincidunt pharetra.",
			"Morbi pretium duiet commodo egestas.",
			"Sed interdum justo indiam pulvinar convallis.",
		],
	},
];
